/**
 * 模板包表状态管理（vuex的state可以单独出来，便于管理，同样mutations和actions都可以提取出来）
 *
 * @author PeterLee
 * @since 2026-01-31
 */
const state = {
   //表单校验规则
   rules: {
      //模板包名称
      packageName:[{
         required: true,
         message: '请输入模板包名称',
         trigger: 'blur'
       },
         {
           min: 1,
           max: 20,
           message: '长度在 1 到 20 个字符',
           trigger: 'blur'
         }
       ],
      //模板包编码
      packageCode:[{
         required: true,
         message: '请输入模板包编码',
         trigger: 'blur'
       },
         {
           min: 1,
           max: 20,
           message: '长度在 1 到 20 个字符',
           trigger: 'blur'
         }
       ],
      //模板包存储路径
      packagePath:[{
         required: false,
         message: '请输入模板包存储路径',
         trigger: 'blur'
       },
         {
           min: 1,
           max: 20,
           message: '长度在 1 到 20 个字符',
           trigger: 'blur'
         }
       ],
      //描述
      description:[{
         required: false,
         message: '请输入描述',
         trigger: 'blur'
      },
        {
         min: 1,
         max: 20,
         message: '长度在 1 到 20 个字符',
         trigger: 'blur'
       }
      ],
      //状态
      state:[{
         required: true,
         message: '请选择状态',
         trigger: 'change'
       }],
   },
   //列信息
   columnInfo: {
       //模板包名称
       packageName:{
            visible:true,
            label:"模板包名称"
       },
       //模板包编码
       packageCode:{
            visible:true,
            label:"模板包编码"
       },
       //模板包存储路径
       packagePath:{
            visible:true,
            label:"模板包存储路径"
       },
       //状态
       state:{
            visible:true,
            label:"状态"
       },
       //描述
       description:{
            visible:true,
            label:"描述"
       },
   },
   //表格数据（查询结果）
   tableData: [],
   //共有数据条数（分页控件）
   totalCount: 0,
   //选项列表（列表下拉框选择）
   options: {
   },
   //查询参数
   queryParams: {
      //当前页数（分页控件）
      currPage: 1,
      //每页条数（分页控件）
      limit: 10,
      //是否升序
      ascOrder: false,
      //排序字段
      orderField: "",
      //此处为可能需要修改部分，请不要忽略
      param: {
         //模板包名称
         packageName: undefined,
         //模板包编码
         packageCode: undefined,
         //模板包存储路径
         packagePath: undefined,
        //状态
        state: undefined,
        //描述
        description: undefined,
      }
   },
   //时间范围
   dateRange: {
   },
   //表单组件信息
   formInfo: {
      //表单组件弹出框显示控制
      dialogVisible: false,
      //是否增加操作（非增加操作会隐藏部分操作）
      isAdd: false,
      //编辑回显数据
      editData: {},
   },
   //更多按钮信息
   moreButtonProps:[
      //{command:'test',label:'示例按钮',permissionCode:'itil:event'}
   ]
}
export default state